import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";

import { store } from "./Redux/Store";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { LoaderProvider } from "./context/LoaderContext";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <LoaderProvider>
            <App />
          </LoaderProvider>
        </BrowserRouter>
      </Provider>
      <Toaster position="bottom-center" richColors />
    </HelmetProvider>
  </React.StrictMode>,
);
